<div class="app-container" ng-version="version">
  <app-confirmation-modal></app-confirmation-modal>
  <app-navigation (navigationMenuAction)="handleNavigationEvent($event)" *ngIf="!showLoginIcon"></app-navigation>
  <div [ngClass]="{ 'menu-open': isMenuOpen(), 'menu-not-open': !isMenuOpen(), 'no-menu': showLoginIcon }" class="app-content-section">
    <div *ngIf="!showLoginIcon" class="app-header-section">
      <div class="title-lsw">
        <i (click)="visitHome()" *ngIf="showHomeIcon()" class="pi pi-home icon-buttons" id="app-icon-home"></i>
        <img alt="logo" src="assets/images/logo-main.png" />
      </div>
      <div class="service-portal-section">
        <div class="title-service-portal">{{ 'app.service_portal' | translate }}</div>

        <div class="header-buttons-section">
          <div *ngIf="role && role !== 'employee'" class="download-center-btn">
            <a [routerLink]="'download-center'">Download Center</a>
          </div>
          <div *ngIf="!showLoginIcon" class="user-email">{{ userEmailId }}</div>
          <app-notifications *ngIf="!showLoginIcon"></app-notifications>
          <i (click)="logout()" *ngIf="!showLoginIcon" class="pi pi-power-off icon-buttons" id="app-icon-logout"></i>
          <i (click)="showLoginForm()" *ngIf="showLoginIcon" class="pi pi-user icon-buttons" id="app-icon-user"></i>
          <select
            #selectedLang
            (change)="useLocalisationLanguage(selectedLang.value)"
            *ngIf="showLanguageSelector"
            class="language-selector"
            id="app-select-language">
            <option
              *ngFor="let language of getLocalisationLanguages()"
              [selected]="language === getCurrentLanguage()"
              [value]="language"
              id="app-option-{{ language }}">
              {{ language }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <p-dialog
      #dialogElement
      *ngIf="displayPosition"
      [(visible)]="displayPosition"
      [baseZIndex]="10"
      [closeOnEscape]="false"
      [draggable]="false"
      [maximizable]="false"
      [modal]="true"
      [resizable]="false"
      [showHeader]="false"
      [style]="{ height: '500px' }"
      styleClass="netz-dialog">
      <app-home></app-home>
    </p-dialog>

    <p-confirmDialog
      #logoutConfirmDialog
      icon="pi pi-info-circle"
      message="{{ 'messages.logout-warning-message' | translate }}"
      styleClass="netz-confirm-dialog">
      <p-footer>
        <button (click)="logoutConfirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
        <button (click)="logoutConfirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
      </p-footer>
    </p-confirmDialog>

    <p-toast key="app-notifier" position="bottom-center">
      <ng-template let-message pTemplate="message">
        <div style="text-align: center">
          <h3>{{ message['data']['msgType'] === 'locale' ? (message['summary'] | translate) : message['summary'] }}</h3>
          <p>{{ message['data']['msgType'] === 'locale' ? (message['detail'] | translate) : message['detail'] }}</p>
        </div>
      </ng-template>
    </p-toast>

    <router-outlet *ngIf="translationsLoaded$ | async" (activate)="onActivate()"></router-outlet>
  </div>
</div>
